<div>
  <div id="general-summary">
    <div id="nodes-container">
      <arm-info-labels infoLabelsId="nodes-connectivity-total"
                   [items]="nodesTotal">
      </arm-info-labels>
      <arm-info-image imageInfoId="nodes-connectivity"
                  [items]="nodesDistribution">
      </arm-info-image>
    </div>

    <div class="fix-clear"></div>

    <div id="peer-connections-container">
      <arm-info-labels infoLabelsId="peer-connections-connectivity-total"
                   [items]="peerConnectionsTotal">
      </arm-info-labels>
      <arm-info-image imageInfoId="peer-connections-connectivity"
                  [items]="peerConnectionsDistribution">
      </arm-info-image>
    </div>

    <div class="fix-clear"></div>

    <div id="connections-container">
      <arm-info-labels infoLabelsId="connections-connectivity-total"
                   [items]="connectionsTotal">
      </arm-info-labels>
      <arm-info-image imageInfoId="connections-connectivity"
                  [items]="connectionsDistribution">
      </arm-info-image>
    </div>
  </div>

  <ac-line-separator title="Test Route"></ac-line-separator>

  <offline-map-summary-test-route></offline-map-summary-test-route>
</div>
